import { Analytics, BugTracker } from "./library";
import { AnyAction, Store } from "redux";
import React, { useEffect, useState } from "react";
import { Route, Router } from "react-router-native";

import Loading from "./screens/Loading";
import Main from "./screens/Main";
import { Provider } from "react-redux";
import { SErrorBoundary } from "./components/templates";
import { ToastContext } from "@density/ui";
import { TokenProvider } from "@densityco/lib-common-auth";
import { createBrowserHistory } from "history";
import createLocalStore from "./store";

// Disable console.log in production
if (!__DEV__) {
  console.log = () => {};
}

export function App() {
  const [store, setStore] = useState<Store | null>(null);

  useEffect(() => {
    createLocalStore().then((result: any) => {
      const newStore: (
        prevState: Store<any, AnyAction> | null
      ) => Store<any, AnyAction> | null = result;
      setStore(newStore);
    });
    BugTracker.init();
    Analytics.init();
  }, []);

  if (!store) {
    return null;
  }

  const history: any = createBrowserHistory();

  return (
    <Provider store={store}>
      <SErrorBoundary>
        <TokenProvider
          fallback={<Loading />}
          children={({ headers }) => {
            return (
              <Router history={history}>
                <Route exact path="/:params">
                  {(match: any) => {
                    return (
                      <ToastContext.Provider value="MULTILINE">
                        <Main match={match} headers={headers} />
                      </ToastContext.Provider>
                    );
                  }}
                </Route>
              </Router>
            );
          }}
        />
      </SErrorBoundary>
    </Provider>
  );
}
